import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { useStores } from "../lib/stores";
import { applyStoreTheme, resetStoreTheme, storeForTheme } from "../lib/storeThemes";

/** Applies store theme inside /app; public pages use :root (VastraKiran Signature). */
export default function StoreThemeSync() {
  const { user } = useAuth();
  const { stores, activeStoreId } = useStores();
  const location = useLocation();

  useEffect(() => {
    const inApp = location.pathname.startsWith("/app");

    if (!inApp || !user || user.role === "super_admin") {
      resetStoreTheme();
      return;
    }

    const profileMatch = location.pathname.match(/\/stores\/([^/]+)\/profile/);
    const profileStore = profileMatch?.[1]
      ? stores.find((s) => s.id === profileMatch[1])
      : null;
    const store = profileStore || storeForTheme(stores, activeStoreId);
    applyStoreTheme(store?.theme);
  }, [user, stores, activeStoreId, location.pathname]);

  return null;
}
